import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { businessUnit } from "../../constants/people";
import { useDispatch } from "react-redux";
import { seperationActions } from "../../store/SeperationSlice";
import GroupIcon from "../../assets/icons/groups.svg";
import ProgressIcon from "../../assets/icons/progress_activity_blue.svg";
import DoubleTickIcon from "../../assets/icons/done_all_green.svg";
import ViewIcon from "../../assets/icons/visibility.svg";
import DownloadIcon from "../../assets/icons/download.svg";
import DocImg from "../../assets/images/doc.png";
import UserIcon from "../../assets/icons/person.svg";
import CloseIcon from "../../assets/icons/emergency_home.svg";
import moment from "moment";
import InitialsCircle from "../InitialsCircle";
import "./SeperationSummary.css";

const SeperationSummary = ({ data, employeeID }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("\n\n\n\ndata in summary", data);
    console.log("employeeID in summary", employeeID);
  }, []);

  const getBusinessUnitColor = (unit) => {
    const color = businessUnit.find((item) => item.value === unit);
    return color ? color.color : "#000000";
  };

  const getValue = (field) => {
    if (field === null || field === undefined) return "NA";
    if (typeof field === "object" && field.value !== undefined)
      return field.value;
    return field;
  };

  const isAnyTaskHaveApprover = (tasks) => {
    if (!tasks || !Array.isArray(tasks)) return false;
    return tasks.some((task) => task?.approver);
  };

  const checkIfClearanceTasksCompleted = () => {
    const payrollStatus = data?.tasks?.find(
      (task) => task.task_name === "Payroll Clearance",
    )?.status;
    return payrollStatus === "Approved" ? true : false;
  };

  const TaskCard = ({ task, reroute = false }) => {
    const handleViewTask = () => {
      dispatch(seperationActions.setExitEmployeeDetails(data));
      navigate("./exit");
    };

    const getAssignedToText = () => {
      switch (task?.task_name) {
        case "IT Clearance":
          return data?.it_approver_name;
        case "Finance Clearance":
          return data?.finance_approver_name;
        case "Admin Clearance":
          return data?.admin_approver_name;
        case "Payroll Clearance":
          return data?.payroll_approver_name;
        default:
          return task?.approver || "Unassigned";
      }
    };

    return (
      <div className="sp-task-card">
        <img
          src={task?.status === "Approved" ? DoubleTickIcon : ProgressIcon}
          alt="progress-ico"
        />
        <div className="div-seperate"></div>
        <div className="sp-task-name">{task?.task_name}</div>
        <div>•</div>
        <div className="sp-subtask-name">
          Triggered on{" "}
          {task?.trigger_date
            ? moment(task?.trigger_date).format("DD MMMM YYYY")
            : "N/A"}
        </div>
        {task?.approved_date && (
          <>
            <div className="div-seperate-sm"></div>
            <div className="sp-subtask-name">
              Approved on{" "}
              {task?.approved_date
                ? moment(task?.approved_date).format("DD MMMM YYYY")
                : "N/A"}
            </div>
          </>
        )}
        <div className="ml-auto">
          {reroute ? (
            <button className="btn btn-view-task" onClick={handleViewTask}>
              View Task
            </button>
          ) : (
            <div className="tsk-app-data">
              <InitialsCircle fullName={getAssignedToText()} size={20} />
              <div className="tsk-app-name">
                Assigned to {getAssignedToText()} {`(${task?.approver})`}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col w-full sp-summary">
      <div className="sp-user-box">
        <div className="sp-user-empid">Employee ID #{data?.employee_id}</div>
        <div className="flex w-full">
          {/* <img className="sp-user-ico" src={UserIcon} alt="User" /> */}
          <InitialsCircle fullName={data?.full_name} size={24} />
          <div className="sp-user-name">{data?.full_name}</div>
          <div
            className="flex sp-user-com"
            style={{
              backgroundColor: getBusinessUnitColor(
                getValue(data?.designation),
              ),
            }}
          >
            <img className="sp-user-icon" src={GroupIcon} alt="emp-icon" />
            <div className="sp-user-text">{getValue(data?.designation)}</div>
          </div>
        </div>
      </div>
      <div className="sp-fm-nav">
        <div className="flex flex-col sp-sum-nav-item items-start">
          <div className="flex">
            <img
              className="sp-nav-succ-img"
              src={DoubleTickIcon}
              alt="DoubleTickIcon"
            />
            <div className="sp-nav-succ-text">Request for Separation</div>
          </div>
          Initiated by {data?.initiator_name} ({data?.initiator_emp_id})
          <div className="sp-nav-succ-date">
            {data?.initiated_date &&
              moment(data?.initiated_date).format("DD MMMM")}
          </div>
        </div>
        <div className="sp-nav-seperator"></div>
        {data?.status === "Approved" ? (
          <div className="flex flex-col sp-sum-nav-item items-start">
            <div className="flex">
              <img
                className="sp-nav-succ-img"
                src={DoubleTickIcon}
                alt="DoubleTickIcon"
              />
              <div className="sp-nav-succ-text">Manager Approval</div>
            </div>
            Approved by {data?.approver_name} ({data?.approver})
            <div className="sp-nav-succ-date">
              {data?.initiated_date &&
                moment(data?.manager_approved_date).format("DD MMMM")}
            </div>
          </div>
        ) : data?.status === "Rejected" ? (
          <div className="flex flex-col sp-sum-nav-item items-start">
            <div className="flex">
              <img
                className="sp-nav-succ-img"
                src={CloseIcon}
                alt="DoubleTickIcon"
              />
              <div className="sp-nav-fail-text">Manager Approval</div>
            </div>
            Rejected by {data?.approver_name} ({data?.approver})
            <div className="sp-nav-fail-date">
              {data?.initiated_date &&
                moment(data?.manager_approved_date).format("DD MMMM")}
            </div>
          </div>
        ) : (
          <div className="sp-sum-nav-item sp-nav-active">
            <img src={ProgressIcon} className="sp-nav-ico" alt="" />
            Manager Approval
          </div>
        )}
        {data?.status !== "Rejected" && isAnyTaskHaveApprover(data?.tasks) && (
          <>
            <div className="sp-nav-seperator"></div>
            {isAnyTaskHaveApprover(data?.tasks) &&
            checkIfClearanceTasksCompleted() ? (
              <div className="flex flex-col sp-sum-nav-item items-start">
                <div className="flex">
                  <img
                    className="sp-nav-succ-img"
                    src={DoubleTickIcon}
                    alt="DoubleTickIcon"
                  />
                  <div className="sp-nav-succ-text">Clearance Tasks</div>
                </div>
                All Tasks Completed
                {data?.exit_feedback_triggered && (
                  <div className="sp-nav-succ-date">
                    {moment(data?.exit_feedback_triggered).format("DD MMMM")}
                  </div>
                )}
              </div>
            ) : (
              <div className={"sp-sum-nav-item sp-nav-active"}>
                <img src={ProgressIcon} className="sp-nav-ico" alt="" />
                Clearance Tasks
              </div>
            )}
          </>
        )}
      </div>

      <div className="sp-sm-head">summary</div>
      <div className="sp-sm">
        <div className="flex flex-wrap sp-sm-box">
          <div className="flex flex-col sp-sm-subbox">
            <div className="sp-sm-label">Date of Resignation</div>
            <div className="sp-sm-value">{data?.date_of_resignation}</div>
          </div>
          <div className="flex flex-col sp-sm-subbox">
            <div className="sp-sm-label">Final Date Of Exit</div>
            <div className="sp-sm-value">{data?.final_date_of_exit}</div>
          </div>
          <div className="flex flex-col sp-sm-subbox1">
            <div className="sp-sm-label">
              Last working Day as per Notice Period
            </div>
            <div className="sp-sm-value">
              {moment(data?.date_of_resignation)
                .add(data?.notice_period || 0, "days")
                .format("DD MMMM YYYY")}
              ({data?.notice_period || 0} Days from resignation date)
            </div>
          </div>
        </div>
        <div className="flex flex-wrap sp-sm-box">
          <div className="flex flex-col sp-sm-subbox">
            <div className="sp-sm-label">Requested Last Working Day</div>
            <div className="sp-sm-value">{data?.req_date_of_exit}</div>
          </div>
          <div className="flex flex-col sp-sm-subbox">
            <div className="sp-sm-label">Recovery Days</div>
            <div className="sp-sm-value">{data?.recovery_days} Days</div>
          </div>
          <div className="flex flex-col sp-sm-subbox1">
            <div className="sp-sm-label">Reason for Separation</div>
            <div className="sp-sm-value">{data?.reason}</div>
          </div>
        </div>
      </div>

      {!data?.can_change_lwd &&
        data?.lwd_block_reason &&
        ["Pending", "Approved"].includes(data?.status) && (
          <div className="sp-cf-subhead" style={{ marginTop: "8px" }}>
            Last working day is locked: {data?.lwd_block_reason}
          </div>
        )}

      {data?.lwd_changes?.length > 0 && (
        <>
          <div className="sp-sm-head mt-20">last working day changes</div>
          <div className="sp-sm">
            {data.lwd_changes.map((chg, idx) => (
              <div className="flex flex-wrap sp-sm-box" key={idx}>
                <div className="flex flex-col sp-sm-subbox">
                  <div className="sp-sm-label">
                    {chg.field_changed === "final_date_of_exit"
                      ? "Final Date of Exit"
                      : "Requested Last Working Day"}
                  </div>
                  <div className="sp-sm-value">
                    {moment(chg.old_date).format("DD MMM YYYY")} {"->"}{" "}
                    {moment(chg.new_date).format("DD MMM YYYY")}
                  </div>
                </div>
                <div className="flex flex-col sp-sm-subbox">
                  <div className="sp-sm-label">Recovery Days</div>
                  <div className="sp-sm-value">
                    {chg.old_recovery_days ?? 0} {"->"}{" "}
                    {chg.new_recovery_days ?? 0} Days
                  </div>
                </div>
                <div className="flex flex-col sp-sm-subbox1">
                  <div className="sp-sm-label">
                    Changed by {chg.changed_by_name || chg.changed_by} (
                    {chg.changed_by}) on{" "}
                    {moment.utc(chg.create_date).local().format("DD MMM YYYY")}
                  </div>
                  <div className="sp-sm-value">{chg.remarks}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {(checkIfClearanceTasksCompleted() && (
        <div className="sp-app-complete">
          <img
            className="sp-nav-succ-img"
            src={DoubleTickIcon}
            alt="DoubleTickIcon"
          />
          {/* <div className="sp-app-complete-text">
            The separation process is successfully complete! Full and final
            settlement will be processed 2-3 days prior to the upcoming payroll
            cycle.
          </div> */}
          <div className="sp-app-complete-text">
            Thank you for supporting their transition. Please ensure all pending
            handovers and documentation are completed, if not already done.
          </div>
        </div>
      )) ||
        ""}

      <div className="flex" style={{ marginTop: "20px" }}>
        <div className="sp-sm-head">comments</div>
        <div className="sp-comment-count">
          {data?.reason_comments && data?.approver_remarks
            ? 2
            : data?.reason_comments
              ? 1
              : data?.approver_remarks
                ? 1
                : 0}
        </div>
      </div>
      <div className="sp-comments">
        <img className="sp-comments-ico" src={UserIcon} alt="User" />
        <div className="flex flex-col">
          <div className="sp-comments-box">
            <div className="sp-comments-name">{data?.initiator_name}</div>
            <div className="sp-comments-text">{data?.reason_comments}</div>
          </div>
          <div className="sp-comment-date">
            {moment(data?.initiated_date).startOf("day").fromNow()}
          </div>
        </div>
      </div>

      {data?.approver_remarks &&
        ((
          <div className="sp-comments mt-2">
            <img className="sp-comments-ico" src={UserIcon} alt="User" />
            <div className="flex flex-col">
              <div className="sp-comments-box">
                <div className="sp-comments-name">{data?.approver_name}</div>
                <div className="sp-comments-text">{data?.approver_remarks}</div>
              </div>
              <div className="sp-comment-date">
                {moment(data?.initiated_date).startOf("day").fromNow()}
              </div>
            </div>
          </div>
        ) ||
          "")}

      {data?.attachments && (
        <>
          <div className="sp-sm-head mt-20 mb-3">attachments</div>
          {/* <div className="sp-sm-head mt-20 mb-0">Instructions on next step</div>
          <div className="sp-sm-subhead">
            Please go through the below mentioned points for smooth process.{" "}
          </div> */}
          <div className="dc-main-box" style={{ width: "391.33px" }}>
            <div className="flex justify-between w-full p-12 mb-auto">
              <div className="flex items-center">
                <div className="dc-card-ico-wrap cursor-no-drop">
                  <img src={ViewIcon} className="dc-card-ico" alt="" />
                </div>
                <div
                  className="dc-card-ico-wrap cursor-pointer"
                  onClick={() => {
                    window.open(data?.attachments, "_blank");
                  }}
                >
                  <img src={DownloadIcon} className="dc-card-ico" alt="" />
                </div>
              </div>
            </div>
            <img className="dc-file-preview" src={DocImg} alt="doc" />
            <div
              className="flex dc-card-nameplate mt-auto w-full p-12"
              style={{ zIndex: 200 }}
            >
              <div className="mr-auto dc-card-filename">
                {data?.attachments &&
                  data?.attachments.split("/").pop().substring(0, 15)}
                ...
              </div>
            </div>
          </div>
        </>
      )}

      {((data?.tasks?.length &&
        isAnyTaskHaveApprover(data.tasks) &&
        data?.status !== "Rejected") ||
        data?.exit_feedback) && (
        <div className="sp-sm-head mt-20 mb-0">clearance tasks</div>
      )}
      {data?.exit_feedback && data?.employee_id === employeeID && (
        <TaskCard
          task={{
            task_name: "Exit Feedback Form",
            trigger_date: data?.exit_feedback_triggered,
            status: !data?.exit_intr ? "Pending" : "Approved",
          }}
          reroute={true}
        />
      )}
      {data?.tasks?.length &&
        isAnyTaskHaveApprover(data.tasks) &&
        data?.status !== "Rejected" && (
          <>
            <div className="flex flex-col sp-card-flow">
              {data?.tasks.map(
                (task, index) =>
                  (task?.approver && <TaskCard key={index} task={task} />) ||
                  "",
              )}
            </div>
          </>
        )}
    </div>
  );
};
export default SeperationSummary;
